/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './timeinterval.scss';
import timeintervalTemplate from './timeinterval.tpl.html';

/* eslint-disable import/no-unresolved, import/default */

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.timeinterval', [])
    .directive('tkTimeinterval', Timeinterval)
    .name;

/*@ngInject*/
function Timeinterval($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(timeintervalTemplate);
        element.html(template);

        scope.rendered = false;

        scope.days = 0;
        scope.hours = 0;
        scope.mins = 1;
        scope.secs = 0;
        scope.msecs = 0;

        scope.setIntervalMs = function (intervalMs) {
            var intervalSeconds = Math.floor(intervalMs / 1000);
            scope.msecs = Math.floor(intervalMs % 1000);
            scope.days = Math.floor(intervalSeconds / 86400);
            scope.hours = Math.floor((intervalSeconds % 86400) / 3600);
            scope.mins = Math.floor(((intervalSeconds % 86400) % 3600) / 60);
            scope.secs = intervalSeconds % 60;
        };

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                var intervalMs = ngModelCtrl.$viewValue;
                scope.setIntervalMs(intervalMs);
            }
            scope.rendered = true;
        };

        function calculateIntervalMs() {
            return (scope.days * 86400 +
                scope.hours * 3600 +
                scope.mins * 60 +
                scope.secs) * 1000 +
                scope.msecs;
        }

        scope.updateView = function () {
            if (!scope.rendered) {
                return;
            }

            var value = null;
            var intervalMs = scope.intervalMs;
            if (!intervalMs || isNaN(intervalMs)) {
                intervalMs = calculateIntervalMs();
            }

            if (!isNaN(intervalMs) && intervalMs > 0) {
                value = intervalMs;
                ngModelCtrl.$setValidity('tk-timeinterval', true);
            } else {
                ngModelCtrl.$setValidity('tk-timeinterval', !scope.required);
            }
            ngModelCtrl.$setViewValue(value);
        };

        scope.$watch('required', function (newRequired, prevRequired) {
            if (angular.isDefined(newRequired) && newRequired !== prevRequired) {
                scope.updateView();
            }
        });

        scope.$watch('min', function (newMin, prevMin) {
            if (angular.isDefined(newMin) && newMin !== prevMin) {
                scope.updateView();
            }
        });

        scope.$watch('max', function (newMax, prevMax) {
            if (angular.isDefined(newMax) && newMax !== prevMax) {
                scope.updateView();
            }
        });

        scope.$watch('intervalMs', function (newIntervalMs, prevIntervalMs) {
            if (angular.isDefined(newIntervalMs) && newIntervalMs !== prevIntervalMs) {
                scope.updateView();
            }
        });

        scope.$watch('msecs', function (newMsecs) {
            if (angular.isUndefined(newMsecs)) {
                return;
            }
            if (newMsecs < 0) {
                if ((scope.days + scope.hours + scope.mins + scope.secs) > 0) {
                    scope.msecs = newMsecs + 1000;
                    scope.secs--;
                } else {
                    scope.msecs = 0;
                }
            } else if (newMsecs >= 1000) {
                scope.msecs = newMsecs - 1000;
                scope.secs++;
            }

            scope.updateView();
        });

        scope.$watch('secs', function (newSecs) {
            if (angular.isUndefined(newSecs)) {
                return;
            }
            if (newSecs < 0) {
                if ((scope.days + scope.hours + scope.mins) > 0) {
                    scope.secs = newSecs + 60;
                    scope.mins--;
                } else {
                    scope.secs = 0;
                }
            } else if (newSecs >= 60) {
                scope.secs = newSecs - 60;
                scope.mins++;
            }

            scope.updateView();
        });

        scope.$watch('mins', function (newMins) {
            if (angular.isUndefined(newMins)) {
                return;
            }
            if (newMins < 0) {
                if ((scope.days + scope.hours) > 0) {
                    scope.mins = newMins + 60;
                    scope.hours--;
                } else {
                    scope.mins = 0;
                }
            } else if (newMins >= 60) {
                scope.mins = newMins - 60;
                scope.hours++;
            }
            scope.updateView();
        });

        scope.$watch('hours', function (newHours) {
            if (angular.isUndefined(newHours)) {
                return;
            }
            if (newHours < 0) {
                if (scope.days > 0) {
                    scope.hours = newHours + 24;
                    scope.days--;
                } else {
                    scope.hours = 0;
                }
            } else if (newHours >= 24) {
                scope.hours = newHours - 24;
                scope.days++;
            }
            scope.updateView();
        });

        scope.$watch('days', function (newDays) {
            if (angular.isUndefined(newDays)) {
                return;
            }
            if (newDays < 0) {
                scope.days = 0;
            }
            scope.updateView();
        });

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            required: '=ngRequired',
            min: '=?',
            max: '=?',
            predefinedName: '=?',
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/timeinterval.directive.js